module.exports = __webpack_public_path__ + "static/media/icons.6921cc66.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons.ttf?pv0exl
// module id = 2535
// module chunks = 7